import { useFeatureFlagEnabled } from "posthog-js/react";
import {
  MATERIOM_COMMONS_DOMAIN,
  MATERIOM_COMMONS_ENTERPRISE_URL_PREFIX,
  MATERIOM_COMMONS_ENTERPRISE_FEATURE_FLAG_NAME,
} from "../constants/";

/**
 * Hook to determine enterprise access based on two conditions:
 * 1. The user is on the enterprise domain (hostname includes "pro.commons")
 * 2. The user belongs to an authorized PostHog cohort (feature flag enabled)
 *
 * @returns {{ isEnterprise: boolean, isEnterpriseDomain: boolean, isAccessDenied: boolean, isFlagLoading: boolean }}
 */
export function useIsEnterprise() {
  const enterpriseDomain = `${MATERIOM_COMMONS_ENTERPRISE_URL_PREFIX}.${MATERIOM_COMMONS_DOMAIN}`;
  const isEnterpriseDomain =
    window.location.hostname === enterpriseDomain ||
    window.location.hostname.endsWith(`.${enterpriseDomain}`);

  const flagValue = useFeatureFlagEnabled(
    MATERIOM_COMMONS_ENTERPRISE_FEATURE_FLAG_NAME
  );
  const isFlagLoading = flagValue === undefined;

  // Enterprise only when on pro domain AND user is in the authorized cohort
  const isEnterprise = isEnterpriseDomain && flagValue === true;

  // Access denied when on pro domain but flag loaded as false
  const isAccessDenied = isEnterpriseDomain && flagValue === false;

  return { isEnterprise, isEnterpriseDomain, isAccessDenied, isFlagLoading };
}
